import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { Provider } from "react-redux";
import { createStore, compose, applyMiddleware } from "redux";
import thunkMiddleware from "redux-thunk";
import allReducers from "./reducers";
import { Routes, Route, Navigate } from "react-router-dom";
import { BrowserRouter } from "react-router-dom";
import App from "./App.js";
let enhancerArray = [applyMiddleware(thunkMiddleware)];

const enhancers = enhancerArray;

const root = ReactDOM.createRoot(document.getElementById("root"));
const store = createStore(allReducers, compose(...enhancers));

root.render(
  <Provider store={store}>
    <BrowserRouter>
      <Routes>
        <Route exact path="/" element={<App />} />
        <Route path="/index.html" element={<App />} />
      </Routes>
    </BrowserRouter>
  </Provider>
);
